export const JOB_POSITION = '/position/job/' as const
export const JOB_POSITION_ALL = `${JOB_POSITION}all` as const
export const JOB_POSITION_ACTIVATE = `${JOB_POSITION}activate/` as const
